"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _rndid = _interopRequireDefault(require("../../utils/rndid"));

var _tokenList = _interopRequireDefault(require("../../utils/token-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TextField =
/*#__PURE__*/
function (_Component) {
  _inherits(TextField, _Component);

  function TextField(props) {
    var _this;

    _classCallCheck(this, TextField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextField).call(this, props));
    _this.inputId = _this.props.id || (0, _rndid["default"])();
    _this.errorId = (0, _rndid["default"])();
    _this.state = {
      value: typeof _this.props.value !== 'undefined' ? _this.props.value : _this.props.defaultValue || ''
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TextField, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;

      if (value === prevProps.value) {
        return;
      }

      this.setState({
        value: value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isRequired = !!this.props.required; // disabling `no-unused-vars` to prevent specific
      // props from being passed through to the input

      var _this$props = this.props,
          label = _this$props.label,
          fieldRef = _this$props.fieldRef,
          value = _this$props.value,
          onChange = _this$props.onChange,
          defaultValue = _this$props.defaultValue,
          _this$props$error = _this$props.error,
          error = _this$props$error === void 0 ? null : _this$props$error,
          requiredText = _this$props.requiredText,
          multiline = _this$props.multiline,
          ariaDescribedby = _this$props['aria-describedby'],
          other = _objectWithoutProperties(_this$props, ["label", "fieldRef", "value", "onChange", "defaultValue", "error", "requiredText", "multiline", "aria-describedby"]);

      var Field = multiline ? 'textarea' : 'input';
      var inputProps = {
        'aria-describedby': error ? (0, _tokenList["default"])(this.errorId, ariaDescribedby) : ariaDescribedby
      };
      return _react["default"].createElement("div", {
        className: "dqpl-field-wrap"
      }, _react["default"].createElement("label", {
        className: (0, _classnames["default"])('dqpl-label', {
          'dqpl-required': isRequired,
          'dqpl-error': error
        }),
        htmlFor: this.inputId
      }, _react["default"].createElement("span", null, label), isRequired && _react["default"].createElement("span", {
        className: "dqpl-required-text"
      }, requiredText)), _react["default"].createElement(Field, _extends({
        className: (0, _classnames["default"])({
          'dqpl-text-input': !multiline,
          'dqpl-textarea': multiline,
          'dqpl-error': error
        }),
        id: this.inputId,
        value: this.state.value,
        onChange: this.onChange,
        "aria-invalid": !!error,
        ref: function ref(input) {
          _this2.input = input;
          fieldRef(input);
        }
      }, other, inputProps)), _react["default"].createElement("div", {
        className: "dqpl-error-wrap",
        id: this.errorId
      }, error));
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      this.props.onChange(this.input.value, e);

      if (typeof this.props.value !== 'undefined') {
        return;
      }

      this.setState({
        value: this.input.value
      });
    }
  }]);

  return TextField;
}(_react.Component);

exports["default"] = TextField;

_defineProperty(TextField, "propTypes", {
  label: _propTypes["default"].node.isRequired,
  id: _propTypes["default"].string,
  error: _propTypes["default"].node,
  defaultValue: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  fieldRef: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  requiredText: _propTypes["default"].string,
  // support localized required text
  multiline: _propTypes["default"].bool,
  'aria-describedby': _propTypes["default"].string
});

_defineProperty(TextField, "defaultProps", {
  error: null,
  required: false,
  defaultValue: null,
  onChange: function onChange() {},
  fieldRef: function fieldRef() {},
  requiredText: 'Required',
  multiline: false
});